<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DKeywordEditor',
  extends: compoment
}
</script>
